import React, {useState} from 'react'
import Container from '../Container'
import { Link } from 'react-router-dom'
import Button from '../Button'
import UploadModal from '../modal/UploadModal'




const Saved = () => {

 
  return (
    <Container>
    
        <div className='grid  h-[inherit] w-[inherit] font-poppins'>
            <div>
            <div className='w-[100%] bg-main-blue h-[22%]  rounded-2xl grid grid-cols-[80%_20%]'>
                    <div className='flex flex-col justify-center pl-10 text-white'>
                        <h1 className='mb-3 flex text-2xl '>
                            Certificate and CV Review    
                        </h1>
                        <div className='flex gap-24'>
                        <Link to = "/uploaded" className='pt-10 text-sm font-normal'>Upload Documents</Link>
                        <Link to = "/saved" className='pt-10 text-sm font-normal' >Saved Documents</Link>
                    </div>
                    </div>
                    </div>
                    <div className='bg-green-100 flex mt-[2rem] p-[1rem] rounded-[1rem] gap-[13rem]'>
                        <p className='text-sm'>File name</p>
                        <p className='text-sm'>File size</p>
                        <p className='text-sm pl-5'>Date of upload</p>
                    </div>
                    <div className='bg-green-100  mt-[1rem] flex flex-col rounded-[1rem]'>
                    <div className=' flex mt-[1rem] p-[1rem]  gap-[7rem]'>
                        <p className='text-sm'>Chinonye Lydia Resume</p>
                        <p className='text-sm'>175kb</p>
                        <p className='text-sm pl-[8rem]'>02-09-2022</p>
                        <Button>View Document</Button>
                    </div>
                    <div className='flex flex-col items-center justify-center p-[20px]'>
                        <hr className='flex flex-col items-center justify-center  w-[100%] ' />
                        </div>
                    <div className=' flex  p-[1rem]  gap-[7rem]'>
                        <p className='text-sm'>Chinonye Lydia Resume</p>
                        <p className='text-sm'>175kb</p>
                        <p className='text-sm pl-[8rem]'>02-09-2022</p>
                        <Button >View Document</Button>
                    </div>
                    </div>
            </div>
        </div>
    </Container>
  )
}

export default Saved